import { memo } from 'react';

import { AirIcon } from '@air/design-icons';

export const PoweredByAir = memo(() => (
  <div className="fixed bottom-4 flex w-full items-center justify-center">
    <p className="ads:text-inverse text-16 text-pigeon-100">Powered by</p>
    <AirIcon size={43} className="ml-1 ads:text-icon-primary text-blue-9" />
  </div>
));

PoweredByAir.displayName = 'PoweredByAir';
